import { render } from "./appEduReleaseLesson.vue?vue&type=template&id=a32009a2&scoped=true"
import script from "./appEduReleaseLesson.vue?vue&type=script&lang=js"
export * from "./appEduReleaseLesson.vue?vue&type=script&lang=js"

import "./appEduReleaseLesson.vue?vue&type=style&index=0&id=a32009a2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32009a2"]])

export default __exports__